"use strict";
'use client';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChartsToolbarZoomInButton = ChartsToolbarZoomInButton;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _Toolbar = require("@mui/x-charts/Toolbar");
var _internals = require("@mui/x-charts/internals");
var _hooks = require("@mui/x-charts/hooks");
var _material = require("../../internals/material");
var _jsxRuntime = require("react/jsx-runtime");
function ChartsToolbarZoomInButton({
  slots,
  slotProps
}) {
  const {
    instance
  } = (0, _internals.useChartContext)();
  const ZoomInIcon = slots?.zoomInIcon ?? _material.defaultSlotsMaterial.zoomInIcon;
  const Tooltip = slots?.baseTooltip ?? _material.defaultSlotsMaterial.baseTooltip;
  const {
    localeText
  } = (0, _hooks.useChartsLocalization)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Tooltip, {
    title: localeText.zoomIn,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Toolbar.ToolbarButton, {
      onClick: () => instance.zoomIn(),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(ZoomInIcon, (0, _extends2.default)({}, slotProps?.zoomInIcon))
    })
  });
}